/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This enum documents existing permissions for the client\'s convenience. It is not referenced elsewhere.
 */
export const PermissionsDTO = {
    SPA_MANAGER: 'spa.manager',
    SPA_API_GATE: 'spa.api.gate',
    SPA_API_MESCAN: 'spa.api.mescan',
    SPA_AREA_ACCESS: 'spa.area.access',
    SPA_AREA_ACCESS_GRANT_READ: 'spa.area.access.grant.read',
    SPA_AREA_ACCESS_GRANT_WRITE: 'spa.area.access.grant.write',
    SPA_MANAGER_REPORTING: 'spa.manager.reporting',
    SPA_MANAGER_CAPACITIES_READ: 'spa.manager.capacities.read',
    SPA_MANAGER_CAPACITIES_WRITE: 'spa.manager.capacities.write',
    SPA_MANAGER_EVENTS_READ: 'spa.manager.events.read',
    SPA_MANAGER_EVENTS_WRITE: 'spa.manager.events.write',
    SPA_MANAGER_CANCELLATIONS_READ: 'spa.manager.cancellations.read',
    SPA_MANAGER_CANCELLATIONS_WRITE: 'spa.manager.cancellations.write',
    SPA_MANAGER_BOOKINGS_READ: 'spa.manager.bookings.read',
    SPA_MANAGER_BOOKINGS_WRITE: 'spa.manager.bookings.write',
    SPA_MANAGER_BOOKINGS_CANCEL: 'spa.manager.bookings.cancel',
    SPA_MANAGER_BOOKINGS_AC: 'spa.manager.bookings.ac',
    SPA_MANAGER_BOOKINGS_COMPANIONS: 'spa.manager.bookings.companions',
    SPA_MANAGER_BOOKINGS_DISCOUNT: 'spa.manager.bookings.discount',
    SPA_MANAGER_BOOKINGS_DIFFERENT_PAYER: 'spa.manager.bookings.differentpayer',
    SPA_MANAGER_BOOKINGS_GUESTS_WITH_DIFFERENT_BOOKING_NUMBERS: 'spa.manager.bookings.guests-with-different-booking-numbers',
    SPA_MANAGER_BOOKINGS_EXTERNAL_ACCESS_ANY: 'spa.manager.bookings.external.access.any',
    SPA_MANAGER_BOOKINGS_UNRESTRICTED_TREATMENT_OPENING_HOURS: 'spa.manager.bookings.unrestricted-treatment-opening-hours',
    SPA_MANAGER_BOOKINGS_UPDATE_RESCHEDULE: 'spa.manager.bookings.update.reschedule',
    SPA_MANAGER_BOOKINGS_UPDATE_EMPLOYEE_ROOM: 'spa.manager.bookings.update.employeeroom',
    SPA_MANAGER_BOOKINGS_24HOURS: 'spa.manager.bookings.24hours',
    SPA_MANAGER_DUTY_SCHEDULE: 'spa.manager.duty.schedule',
    SPA_MANAGER_CALENDAR_READ: 'spa.manager.calendar.read',
    SPA_MANAGER_CONFIGURATION_ROOM_READ: 'spa.manager.configuration.rooms.read',
    SPA_MANAGER_CONFIGURATION_ROOM_WRITE: 'spa.manager.configuration.rooms.write',
    SPA_MANAGER_CONFIGURATION_EMPLOYEES_READ: 'spa.manager.configuration.employees.read',
    SPA_MANAGER_CONFIGURATION_EMPLOYEES_WRITE: 'spa.manager.configuration.employees.write',
    SPA_MANAGER_CONFIGURATION_PRODUCTS_READ: 'spa.manager.configuration.products.read',
    SPA_MANAGER_CONFIGURATION_PRODUCTS_WRITE: 'spa.manager.configuration.products.write',
    SPA_MANAGER_CONFIGURATION_PRODUCTS_AVAILABLE_WRITE: 'spa.manager.configuration.products.available.write',
    SPA_MANAGER_CONFIGURATION_PRODUCTS_EXTERNAL_ACCESS_WRITE: 'spa.manager.configuration.products.externalaccess.write',
    SPA_MANAGER_QS_TOOLS: 'spa.manager.tools.qs',
    SPA_MANAGER_UI: 'spa.manager.ui',
    SPA_MANAGER_GATE_EVENTS_READ_ANY: 'spa.manager.gate.events.read.any',
    SPA_MANAGER_PREPAID_MANAGE: 'spa.manager.prepaid.manage',
    SPA_MANAGER_PREPAID_READ: 'spa.manager.prepaid.read',
    SPA_MANAGER_PREPAID_EDIT: 'spa.manager.prepaid.edit',
    SPA_MANAGER_PREPAID_REPORT: 'spa.manager.prepaid.report'
} as const;
export type PermissionsDTO = typeof PermissionsDTO[keyof typeof PermissionsDTO];

